import { InventoryDataSource } from '@ekhodealer/ekho-common';

export const FIELD_NAME_TO_LABEL = {
	msrp: 'MSRP',
	dealerRetail: 'Dealer retail price',
	advertisedPrice: 'Advertised price',
	retailPrice: 'Retail price',
};

export const DATA_SOURCE_LABELS: Record<InventoryDataSource, string> = {
	[InventoryDataSource.DMS]: 'DMS',
	[InventoryDataSource.WEBSITE]: 'Website',
	[InventoryDataSource.OEM]: 'OEM',
	[InventoryDataSource.EKHO]: 'Ekho',
};
